import MenuItem from '@mui/material/MenuItem';
import Skeleton from '@mui/material/Skeleton';
import { typedMemo } from '@utils';

export const ProjectMenuItemSkeleton = typedMemo(() => {
  return (
    <div data-testid="project-menu-item-skeleton">
      {Array.from({ length: 4 }, (_, index) => (
        <MenuItem key={`skeleton-${index}`}>
          <div
            style={{ display: 'flex', flexDirection: 'column', width: '100%' }}
          >
            <Skeleton variant="text" width="60%" height={20} />
            <Skeleton variant="text" width="40%" height={16} />
          </div>
        </MenuItem>
      ))}
    </div>
  );
});
